// @flow
import cn from 'classnames';
import {Loader} from 'modules/common/components/Loader';
import React from 'react';
import styles from './styles.local.less';

type TProps = {
    children: React$Node,
    className?: string,
    disabled?: boolean,
    fullWidth?: boolean,
    iconLeft?: React$Node,
    iconRight?: React$Node,
    isLoading?: boolean,
    isWarning?: boolean,
    isWarningFill?: boolean,
    isWhite?: boolean,
    onClick?: (SyntheticEvent<HTMLButtonElement>) => Promise<void> | void,
    type?: string,
};

/**
 * Кнопка
 * @param props Свойства
 * @returns React-компонент
 */
export const Button = ({
    children,
    className,
    disabled,
    fullWidth,
    onClick,
    iconLeft,
    iconRight,
    isLoading,
    isWarning,
    isWarningFill,
    isWhite,
    type = 'button',
}: TProps) => {
    return (
        <button
            className={cn(className, styles.button, {
                [styles.disabledPrimaryButton]: disabled && !isWhite,
                [styles.whiteButton]: isWhite,
                [styles.warningButton]: isWarning,
                [styles.warningFillButton]: isWarningFill,
                [styles.disabledWhiteButton]: disabled && isWhite,
                [styles.withIconButton]: iconLeft || iconRight,
                [styles.fullWidthButton]: fullWidth,
                [styles.disableTouch]: isLoading,
            })}
            disabled={disabled}
            onClick={onClick}
            type={type}
        >
            {iconLeft && <span className={cn(styles.leftIcon, 'icon')}>{iconLeft}</span>}
            {isLoading ? <Loader opacity={!isWhite && !isWarning} warning={isWarning} /> : children}
            {iconRight && <span className={cn(styles.rightIcon, 'icon')}>{iconRight}</span>}
        </button>
    );
};
